<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>Administration</small>
        <br>
        Base de données
      </h1>
      <hr>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="panel-title">
            Éxécution d'un script serveur
          </div>
        </div>
        <div class="panel-body">
          <label>Chemin du script sur le serveur</label>
          <input required
                 class="form-control"
                 :disabled="script.waiting"
                 v-model.trim="script.name"
                 placeholder="Chemin du script..."/>
        </div>
        <div class="panel-footer">
          <div v-if="script.error !== ''">
            <alert type="danger">{{ script.error }}</alert>
          </div>
          <btn type="danger"
               :disabled="script.waiting || script.name === ''"
               block
               @click="confirmScript">
            Lancer
          </btn>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="panel-title">
            Mise à jour de la base
          </div>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-6 text-center">
              <p>Version actuelle</p>
              <h3>{{ current }}</h3>
            </div>
            <div class="col-xs-6 text-center">
              <p>Version disponible</p>
              <h3>{{ available }}</h3>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div v-if="version.error !== ''">
            <alert type="danger">{{ version.error }}</alert>
          </div>
          <btn type="warning"
               :disabled="upgradeDisabled"
               block
               @click="confirm">
            Mettre à jour
          </btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { confirm } from '@/sui/tools/modal'
import { mapGetters } from 'vuex'

const impl = {
  formatVersion (v) {
    return v === -1 ? 'N/A' : v
  }
}

export default {
  name: 'admin-db',

  data: function () {
    return {
      version: {
        upgrading: false,
        error: ''
      },
      script: {
        waiting: false,
        name: '',
        error: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      versions: 'admin/versions'
    }),

    upgradeDisabled: function () {
      return this.version.upgrading || this.versions.available <= this.versions.current
    },

    current: function () {
      return impl.formatVersion(this.versions.current)
    },

    available: function () {
      return impl.formatVersion(this.versions.available)
    }
  },

  methods: {
    confirm: function () {
      const { current, available } = this.versions
      confirm(
        this,
        `Êtes-vous sûr.e de vouloir mettre à jour la base de données
de la version <strong>${current}</strong> à la version
<strong>${available}</strong> ?`
      ).then(() => {
        this.upgrade(available)
      }).catch(() => {})
    },

    upgrade: function (version) {
      const vm = this
      this.version.upgrading = true
      this.version.error = ''
      this.$store.dispatch('admin/upgradeDb', { v: version }).then(
        (response) => {
          vm.version.upgrading = false
          if (response.data.err != null) {
            vm.version.error = `Erreur pendant la mise à jour : ${response.data.err}`
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Base de données mise à jour avec succès !'
              }
            )
          }
        }
      ).catch(
        (e) => {
          vm.version.upgrading = false
          vm.version.error = `Erreur pendant la mise à jour : ${e.toString()}`
        }
      )
    },

    confirmScript: function () {
      const { name } = this.script
      confirm(
        this,
        `Êtes-vous sûr.e de vouloir éxécuter le script
<strong>${name}</strong> sur le serveur ?`
      ).then(() => {
        this.runScript()
      }).catch(() => {})
    },

    runScript: function () {
      const vm = this
      this.script.waiting = true
      this.script.error = ''
      this.$store.dispatch('admin/runScript', { f: this.script.name }).then(
        (response) => {
          vm.script.waiting = false
          vm.script.name = ''
          if (response.data.err != null) {
            vm.script.error = `Erreur pendant le script : ${response.data.err.toString()}`
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Script lancé avec succès !'
              }
            )
          }
        }
      ).catch(
        (e) => {
          vm.script.waiting = false
          vm.script.name = ''
          vm.script.error = `Erreur pendant le script : ${e.toString()}`
        }
      )
    }
  },

  mounted: function () {
    this.$store.dispatch('admin/dbVersions')
  }
}
</script>

<style scoped lang="less">
</style>
